export default  [
 // Happy 
 {
   "title": "happy dance Sticker by Amazon Music",
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExa2drOXZhYjVpZmFndmsxamI1c2phMjcwazkxZmpkYWVkZDZzbnN2MiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/lrbYnn0TYeRbiAtw17/giphy.gif",
   "SentimentScore": 0.7,
   "Category": "Happy",
   "is_sticker":1
 }, 
 // {
 //   "title": "",
 //   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExdnl3NjQwdjJvdWI5bHVmZW8zazlrcW5vZDlkY3Vyd2Jjczh3YzN6aiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/P5oR6quIlmsEu8fd65/giphy.gif",
 //   "SentimentScore": 0.868,
 //   "Category": "Happy",
 //   "is_sticker":1
 // },   
   {
   // Drawn heart 
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMnc3eHVzOXR5d2N6bDI0eGoycDczbDA0N3dqcWRuc29vZWd6ZXBsNyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/tpnrOQ2cVFVOD2UBg4/giphy.gif?ep=v1_stickers_search",
   "SentimentScore": 0.568,
   "Category": "Happy",
   "is_sticker":1
 }, 
    {
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExeGhxejBvbjN1YmhpYWM4Nm9xc2NzNzZrczMyc25xb3Y2ZjlmdXNjOSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/Y3HTF8WdRpEFIu3FA8/giphy.gif",
   "SentimentScore": 0.8,
   "Category": "Happy",
   "is_sticker":1
 }, 
    {
   // Smiling Sun
   "GifURL": "https://media.giphy.com/media/NA0IHGzqY5HwYbBGT1/giphy.gif",
   "SentimentScore": 0.8,
   "Category": "Happy",
   "is_sticker":1
 },
    {
   // Shooting star
   "GifURL": "https://media.giphy.com/media/YR0mqqaoEwFpzVXo07/giphy.gif",
   "SentimentScore": 0.8,
   "Category": "Happy",
   "is_sticker":1
 },
    {
   // Smiling Heart
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExdWw4b2JnZjBoNm53Nmt5eWdhNmd0c2RwbHJ6OWdpbG5yaTVpZ2JveCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/VDHK6n1MiXVmo4Xs2u/giphy.gif",
   "SentimentScore": 0.8,
   "Category": "Happy",
   "is_sticker":1
 },
    {
   // 3 Flowers
   "GifURL": "https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExcGJsbDhjaGhzeDZ5dXdobmg2cm56bnlvczJ2OG00aTN3MXcyN2VtaCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/iJJOmgeWguyXBXh7C6/giphy.gif",
   "SentimentScore": 0.8,
   "Category": "Happy",
   "is_sticker":1
 },
    {
   // Happy Coffee Smiling
   "GifURL": "/images/stickers/happy_coffee_smile.gif",
   "SentimentScore": 0.8,
   "Category": "Happy",
   "is_sticker":1,
   "Premium": "true"
 },
    
 //    {
 //   // Yes
 //   "GifURL": "https://media.giphy.com/media/DTSR3Ku7zr2WDqcyTv/giphy-downsized-large.gif",
 //   "SentimentScore": 0.8,
 //   "Category": "Happy",
 //   "is_sticker":1
 // }, 

 // Sad
 {
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExbWwxemFrbGoyNXFvY2Y3MGxpYzl1eWtxeWkxcG9xbzg2M2k0Ym1zZCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/kAtyaucAHzBDNza4oc/giphy.gif",
   "SentimentScore": -0.5,
   "Category": "Sad",
   "is_sticker":1
 },  
 {
   // Sad Flower
   "GifURL": "https://media.giphy.com/media/AKf8Y2H8BR8YRHDVg1/giphy.gif",
   "SentimentScore": -0.5,
   "Category": "Sad",
   "is_sticker":1
 },   
  {
   // Sad Heart
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExOWFpMmxsMHNmY25zYmd2ZjhhZDUzdWVnMTVqd2JkZDd4Ym9oNDMwZiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/rX1XPZKeDI7vurHdin/giphy.gif",
   "SentimentScore": -0.5,
   "Category": "Sad",
   "is_sticker":1
 }, 
 {
   // Sad Cloud
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMTdkbWYxbzI5aGgweTcyMGV1YmxlcmczcmJ4eXJxNTVkY25sNDN3MSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/McOkHi1s4yXmCztGRM/giphy.gif",
   "SentimentScore": -0.5,
   "Category": "Sad",
   "is_sticker":1
 },    
 {
   // Sad heart 2
   "GifURL": "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExMXlhbGMxdHNyMHhiNWthdm1sYm5wN2p6bTYwNzl4b2tiMnlpZjl2MyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/xzU3MjVfx6qjEDaag6/giphy.gif",
   "SentimentScore": -0.5,
   "Category": "Sad",
   "is_sticker":1
 },    
 {
   // Sad Coffee Cup
   "GifURL": "/images/stickers/Sad_Coffee-Cup.gif",
   "SentimentScore": -0.5,
   "Category": "Sad",
   "is_sticker":1,
   "Premium": "true"
 },    
 // Stressed  
 {
  // Space Invader
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNWR6c2s1NjF0bnFpbGp5d3hwM2k3NWR1ZXQyMTZnMGR2bWw0cGE1ZyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/MfSdxfJDocLu0/giphy.gif",
   "SentimentScore": -0.2,
   "Category": "Stressed",
   "is_sticker":1
 }, 
  {
  // Arghhh
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExZXpsbzh4MXFoZmF2amdhc244YTMxNTFidzc5dHNzbTlieHowOTVmbSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/hL6mhYHSvgkpNdhVLp/giphy.gif",
   "SentimentScore": -0.2,
   "Category": "Stressed",
   "is_sticker":1
 },  
  {
  // Cartoon Stressed
   "GifURL": "https://media0.giphy.com/media/4F07bhLsRHZEyHzhka/giphy.gif?cid=9b38fe915aa3doojy6q3xoon26uvdwgpy2l1zpxwmisyy3gj&ep=v1_stickers_search&rid=giphy.gif&ct=s",
   "SentimentScore": -0.2,
   "Category": "Stressed",
   "is_sticker":1
 },  
  {
  // Hour Glass
   "GifURL": "/images/stickers/stressed_hour-glass.gif",
   "SentimentScore": -0.2,
   "Category": "Stressed",
   "is_sticker":1,
   "Premium": "true"
 },  
 // Busy
 {
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMnkzcG82a2cxNXZjdHFyeG5nMTFxdnk3dmFtOTBvcmtremR4NjNldyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/nEFUvbIzWncvp025xb/giphy.gif",
   "SentimentScore": 0.2,
   "Category": "Busy",
   "is_sticker":1
 }, 
 // Busy Clock
 {
   "GifURL": "/images/stickers/Busy_clock.gif",
   "SentimentScore": 0.2,
   "Category": "Busy",
   "is_sticker":1,
    "Premium": "true"
 }, 
 // Coding Python
 {
   "GifURL": "/images/stickers/busy_coding-python.gif",
   "SentimentScore": 0.1,
   "Category": "Busy",
   "is_sticker":1,
    "Premium": "true"
 }, 
 {
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExb2t5azB5YW9raDdlaGR2eXk3cHRqbnowYXcxM3dnanplcG44MGt0YSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/jQ8sGUX6xYTfchDsCw/giphy.gif",
   "SentimentScore": 0.3,
   "Category": "Busy",
   "is_sticker":1
 },
 {
  "GifURL": "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExOGVvNHM2YnAycjlxdDA4bGRmcWhtc21yZGczendieG54Y3VjcGhyMSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9dHM/ksE9feSa2b4V2GYwY4/giphy.gif",
  "SentimentScore": 0.3,
  "Category": "Busy",
  "is_sticker":1
},
 
 
 // Tired
 {
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExYnU5cHd4ZDI4ZDVnY29zcHByc2xueG1pYnN3aWJ2NDU4eTV0eGViaiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/kDqRubyEnzKbOgTV6M/giphy.gif",
   "SentimentScore": 0.2,
   "Category": "Tired",
   "is_sticker":1
 },
 {
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExZXhuNjYyNG92eTY2YXA1MmE4eXdvM2xpZTluNGJmdjg1dHRpMThpNSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/5rtGHJ7ibzPYbyMzkA/giphy.gif",
   "SentimentScore": 0.2,
   "Category": "Tired",
   "is_sticker":1
 }, 
 { 
   // Coffee cup
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExcHZ3bXRlZGU3eDc4MHpiMnphamZtYnd6aWRubXkzdDkxNGJkZ24wZSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/JXf2EDCfBL8BnGMNlK/giphy.gif",
   "SentimentScore": 0.2,
   "Category": "Tired",
   "is_sticker":1
 }, 
 { 
   // Filter Coffee
   "GifURL": "/images/stickers/tired_filter-coffee.gif",
   "SentimentScore": 0.2,
   "Category": "Tired",
   "is_sticker":1
 }, 
 // Angry 
 {
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExbTA1cHIxYjN1dWgyeDkzaDhkMDUyd21rZDJuYWUwY2owaWM1bDQzMiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/enqN61wSFBKI7S5Ofa/giphy.gif",
   "SentimentScore": -0.5,
   "Category": "Angry",
   "is_sticker":1
 }, 
 // Worried
 // {
 //   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExazNoYzhyMzF2Nm8wb3p5OHkwNWoxOXdyOThhcjVheHNrMHI4MTVqciZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/l4pT1YVunxJ7g11O8/giphy.gif",
 //   "SentimentScore": -0.5,
 //   "Category": "Worried",
 //   "is_sticker":1
 // },
 {
   // Red Alien
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExaDJlcDFuOWJvNDFzYWUyNmZoYjB4eGxpbzBnczE5YXlpbHgxYTl4byZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/cq8qwbRUWruRG/giphy.gif",
   "SentimentScore": -0.5,
   "Category": "Worried",
   "is_sticker":1
 },  
 {
   // Worried Eyes
   "GifURL": "https://media.giphy.com/media/9PvkZLdw8C8hzq5R0O/giphy.gif",
   "SentimentScore": -0.5,
   "Category": "Worried",
   "is_sticker":1
 }, 

   // Winning
  {
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExYTU3b3JsOTg2NXhpZWN5ZG96ODQwNHU4Z3VvNjhucmEybnRoaTQwNyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/GlHV2O0IpxAsRjVsNb/giphy.gif",
   "SentimentScore": .5,
   "Category": "Winning",
   "is_sticker":1
 },   
 // {
 //   // Working it walk
 //   "GifURL": "https://media.giphy.com/media/f8OlhuymAfwE5iygfJ/giphy.gif",
 //   "SentimentScore": .7,
 //   "Category": "Winning",
 //   "is_sticker":1
 // },
   // Celebrating
  {
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExY3MxOWVxZHA2Z3A0eTk5MXp2bjlkM3pkbnZqa2kxcWlsY3VldWRldyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/6shqJXI17wnrJjUdv3/giphy.gif",
   "SentimentScore": .5,
   "Category": "Celebrating",
   "is_sticker":1
 },  
 {
   // Confetti Canon 
   "GifURL": "https://media.giphy.com/media/FJaKqj9YG8cw6FeW8b/giphy.gif",
   "SentimentScore": .8,
   "Category": "Celebrating",
   "is_sticker":1
 }, 
 {
   // Balloons
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNGd4ZW14dG5rajg0eXNra3puMDc5NjA3dnpheWk2Njh2N2RvbnEybiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/afZ0gJaIqYQOZYl39K/giphy.gif",
   "SentimentScore": .7,
   "Category": "Celebrating",
   "is_sticker":1
 },
  // It's Monday!
  {
   "GifURL": "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExanJiNGtnbXE1aTVqeDN1Z3FjNDJoYnh2czN2ZTBjYzV0bW85cW8ydCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/L4aAgc5N1Zo9qJOJYB/giphy.gif",
   "SentimentScore": 0,
   "Category": "It's Monday!",
   "is_sticker":1
 },
  // Question Mark
  {
    "GifURL": "https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExZTB3aGVieGxkeXJtcjJxeGhtd2Z5aWVudDNqaDZueWNyNHRuenl0aSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/29JECTcAnn15UmY4rQ/source.gif",
    "SentimentScore": -0.2,
    "Category": "Confused or Lost",
    "is_sticker":1
  },
  // TV Static
  {
    "GifURL": "https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExYjlhYzh2MnVqOTBxN3NqNmFsZmllZDJmcTdsZ2ZlamltMGw3dzlvMCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/ztm2TsXkrUeQ0/giphy.gif",
    "SentimentScore": -0.1,
    "Category": "Confused or Lost",
    "is_sticker":1
  },
  // Cassette
  {
    "GifURL": "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExZHNjcXh6cXB6eGhrYzdqZ3NnYzV4eXFvZjV0dzBua3VoMjRjc2RsZCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/11OHbMp7tv64zm/giphy.gif",
    "SentimentScore": 0.4,
    "Category": "Inspired",
    "is_sticker":1
  },
  /** Holiday */
  {
    "GifURL": "https://media1.giphy.com/media/9x4Yql3exPcawXnReb/200.gif?cid=d749521b4hpazs6vl7zfonm8wxb3dogz530yziodjxvunyy8&ep=v1_stickers_search&rid=200.gif&ct=s",
    "SentimentScore": .5,
    "Category": "Holiday",
    "is_sticker":1
  },
   // beachball
   {
    "GifURL": "/images/stickers/holiday_beach-ball.gif",
    "SentimentScore": 0.5,
    "Category": "Holiday",
    "is_sticker":1
  },
  // Beachball
  // {
  //   "GifURL": "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExMHd3MHQzbjZnMndkNW5idzFhcWpybjZ2dWc5ZDNnbDF2bHU0anRreSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/mPtjEIaSplWvoChSMc/giphy.gif",
  //   "SentimentScore": 0.6,
  //   "Category": "Holiday",
  //   "is_sticker":1
  // },
  /** Hot */
  // Fan
  {
    "GifURL": "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExbjBoNmt0N3M4YzFjbXIwcHo0aXQyYjlhandpNWRoZGk0ZjM5NXZvcCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/GhJVlSfEWhcycSKWAQ/giphy.gif",
    "SentimentScore": 0.1,
    "Category": "Hot",
    "is_sticker":1
  },
  /** Lost */
  {
    "GifURL": "/images/stickers/lost_space-man.gif",
    "SentimentScore": 0.2,
    "Category": "Confused or Lost",
    "is_sticker":1,
    "Premium": "true"
  },
  {
    "GifURL": "images/stickers/lost_maze-little-purple.gif",
    "SentimentScore": -0.2,
    "Category": "Confused or Lost",
    "is_sticker":1,
    "Premium": "true"
  }
]